"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliveryHubDruidCube = exports.OwnFleetDruidCube = exports.CubeDataSource = exports.PredefinedDateRange = exports.TimeDimensionGranularityEnum = void 0;
var TimeDimensionGranularityEnum;
(function (TimeDimensionGranularityEnum) {
    TimeDimensionGranularityEnum["hour"] = "hour";
    TimeDimensionGranularityEnum["day"] = "day";
    TimeDimensionGranularityEnum["week"] = "week";
    TimeDimensionGranularityEnum["month"] = "month";
    TimeDimensionGranularityEnum["year"] = "year";
})(TimeDimensionGranularityEnum || (exports.TimeDimensionGranularityEnum = TimeDimensionGranularityEnum = {}));
var PredefinedDateRange;
(function (PredefinedDateRange) {
    PredefinedDateRange["today"] = "today";
    PredefinedDateRange["yesterday"] = "yesterday";
    PredefinedDateRange["tomorrow"] = "tomorrow";
    PredefinedDateRange["this week"] = "this week";
    PredefinedDateRange["this month"] = "this month";
    PredefinedDateRange["from 6 days ago to now"] = "from 6 days ago to now";
    PredefinedDateRange["from 29 days ago to now"] = "from 29 days ago to now";
    PredefinedDateRange["last month"] = "last month";
    PredefinedDateRange["next 7 days"] = "next 7 days";
    PredefinedDateRange["next 30 days"] = "next 30 days";
    PredefinedDateRange["next month"] = "next month";
})(PredefinedDateRange || (exports.PredefinedDateRange = PredefinedDateRange = {}));
var CubeDataSource;
(function (CubeDataSource) {
    CubeDataSource["Presto"] = "prestodb";
    CubeDataSource["Druid"] = "druid";
})(CubeDataSource || (exports.CubeDataSource = CubeDataSource = {}));
var OwnFleetDruidCube;
(function (OwnFleetDruidCube) {
    OwnFleetDruidCube["Tasks"] = "TasksDruid";
    OwnFleetDruidCube["CustomerEngagement"] = "CustomerEngagement";
    OwnFleetDruidCube["FleetEvents"] = "FleetEvents";
    OwnFleetDruidCube["Runs"] = "Runs";
    OwnFleetDruidCube["TosModelEvaluation"] = "TosModelEvaluation";
})(OwnFleetDruidCube || (exports.OwnFleetDruidCube = OwnFleetDruidCube = {}));
var DeliveryHubDruidCube;
(function (DeliveryHubDruidCube) {
    DeliveryHubDruidCube["Shipments"] = "ShipmentsDruid";
})(DeliveryHubDruidCube || (exports.DeliveryHubDruidCube = DeliveryHubDruidCube = {}));
//# sourceMappingURL=cubejs.js.map